export const FilterOptions = {
	Click: 'filter_click',
	Remove: 'filter_remove',
};
